module.exports = __webpack_public_path__ + "img/kGold.884246a.png";